<template>
  <section :class="blockClass">
    <div class="solutions-wheel__bg"></div>
    <!-- <div class="solutions-wheel__ribbon"></div> -->
    <div class="solutions-wheel__container">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 typography solutions-wheel__header">
            <ContentArea :content="data" title_field_tag="h1" />
          </div>
        </div>
      </div>
      <div class="solutions-wheel__body" id="solutions-wheel-body">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-4">
              <div class="solutions-wheel__wheel">
                <div class="solutions-wheel__wheel__icon">
                  <div class="inner">
                    <inline-svg
                      v-if="currentIcon"
                      :src="currentIcon"                      
                    />
                  </div>
                </div>
                <div class=" solutions-wheel__wheel__circle">
                  <div
                    class="solutions-wheel__wheel__circle__pointer"
                    :style="pointerStyle"
                  ></div>
                  <div
                    class="solutions-wheel__wheel__circle__hover"
                    :style="hoverStyle"
                  ></div>
                  <div
                    :class="segmentClass(index)"
                    v-for="(solution, index) in data.solutions"
                    :key="index"
                    :style="segmentStyle(index)"
                    @click="setCurrentSolution(index)"
                    @mouseover="hoverSegment(index)"
                  >
                    <div
                      class="solutions-wheel__wheel__circle__segment__title"
                      :style="segmentTitleStyle(index)"
                    >
                      <p>{{ solution.title }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-4 solutions-wheel__content typography">
              <div class="col-12 col-md-6 solutions-wheel__content__nav">
                <button
                  @click.prevent="previousSegment"
                  @mousedown="
                    addHoverClass(
                      '.solutions-wheel__content__nav__button--prev'
                    )
                  "
                  @mouseup="
                    removeHoverClass(
                      '.solutions-wheel__content__nav__button--prev'
                    )
                  "
                  @mouseleave="
                    removeHoverClass(
                      '.solutions-wheel__content__nav__button--prev'
                    )
                  "
                  class="solutions-wheel__content__nav__button solutions-wheel__content__nav__button--prev"
                >
                  <svg
                    id="icon_-_arrow_left_01"
                    data-name="icon - arrow left 01"
                    xmlns="http://www.w3.org/2000/svg"
                    width="5.918"
                    height="9.492"
                    viewBox="0 0 5.918 9.492"
                  >
                    <path
                      id="Path_24"
                      data-name="Path 24"
                      d="M11.074-13.5,6.328-8.75,11.074-4l1.172-1.172L8.672-8.75l3.574-3.574Z"
                      transform="translate(-6.328 13.496)"
                      fill="#fff"
                    />
                  </svg>
                </button>
                <button
                  @click.prevent="nextSegment"
                  @mousedown="
                    addHoverClass(
                      '.solutions-wheel__content__nav__button--next'
                    )
                  "
                  @mouseup="
                    removeHoverClass(
                      '.solutions-wheel__content__nav__button--next'
                    )
                  "
                  @mouseleave="
                    removeHoverClass(
                      '.solutions-wheel__content__nav__button--next'
                    )
                  "
                  class="solutions-wheel__content__nav__button solutions-wheel__content__nav__button--next"
                >
                  <svg
                    id="icon_-_arrow_left_01"
                    data-name="icon - arrow left 01"
                    xmlns="http://www.w3.org/2000/svg"
                    width="5.918"
                    height="9.492"
                    viewBox="0 0 5.918 9.492"
                  >
                    <path
                      id="Path_24"
                      data-name="Path 24"
                      d="M11.074-13.5,6.328-8.75,11.074-4l1.172-1.172L8.672-8.75l3.574-3.574Z"
                      transform="translate(-6.328 13.496)"
                      fill="#fff"
                    />
                  </svg>
                </button>
              </div>

              <div class="solutions-wheel__content__solution-info typography">
                <h3>{{ currentSolution.title }}</h3>
                <div v-html="currentSolution.content"></div>
              </div>
            </div>

            <div class="col-12 col-md-4 solutions-wheel__content typography">
              <div class="solutions-wheel__content__solution-info solutions-wheel__content__solution-info--links typography">
                <div v-html="currentSolution.links"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ContentArea from "./ContentArea";
import { isMobile } from "mobile-device-detect";

export default {
  name: "SolutionsWheel",
  components: { ContentArea },
  data: function() {
    return {
      data: window.solutions_wheel,
      active_solution_index: 0,
      pointer_index: 0,
      current_wheel_rotation: 0,
      hover_segment_index: 0
    };
  },
  computed: {
    blockClass() {
      let blockClass = "solutions-wheel";
      if (this.data.background_colour) {
        blockClass += " block--background-" + this.data.background_colour;
      }
      return blockClass;
    },
    currentSolution() {
      return this.data.solutions[this.active_solution_index];
    },
    currentIcon() {
      if (this.currentSolution.icon) {
        return this.currentSolution.icon.sizes.thumbnail;
      } else {
        return null;
      }
    },
    pointerStyle() {
      let degreesRotate = this.degreesPerSegment() * this.pointerIndex;
      return {
        transform: "rotate(" + degreesRotate + "deg)"
      };
    },
    pointerIndex() {
      return this.pointer_index;
    },
    hoverStyle() {
      let degreesRotate = this.degreesPerSegment() * this.hover_segment_index;
      return {
        transform: "rotate(" + (degreesRotate)  + "deg)"
      };
    },
    solutionCount() {
      return this.data.solutions.length;
    }
  },
  methods: {
    addHoverClass(buttonClass) {
      let buttonEl = document.querySelector(buttonClass);
      buttonEl.classList.add("solutions-wheel__content__nav__button--hover");
    },
    removeHoverClass(buttonClass) {
      let buttonEl = document.querySelector(buttonClass);
      buttonEl.classList.remove("solutions-wheel__content__nav__button--hover");
    },
    scrollToPosition() {
      let wheelHeight = document.querySelector(".solutions-wheel__wheel")
        .offsetHeight;

      var options = {
        easing: "ease-in",
        offset: wheelHeight / 2 - 55,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };

      if (isMobile) {
        this.$scrollTo("#solutions-wheel-body", 500, options);
      }
    },
    previousSegment() {
      if (this.active_solution_index === 0) {
        this.active_solution_index = this.solutionCount - 1;
      } else {
        --this.active_solution_index;
      }
      --this.pointer_index;
      this.scrollToPosition();
    },
    nextSegment() {
      if (this.active_solution_index === this.solutionCount - 1) {
        this.active_solution_index = 0;
      } else {
        ++this.active_solution_index;
      }
      ++this.pointer_index;
      this.scrollToPosition();
    },
    hoverSegment(index) {
      this.hover_segment_index = index;
    },
    degreesPerSegment() {
      const degreesPerSolution = 360 / this.solutionCount;
      return degreesPerSolution;
    },
    setCurrentSolution(index) {
      this.active_solution_index = index;
      this.pointer_index = index;
      this.scrollToPosition();
    },
    segmentStyle(index) {
      // Calculate the amount to rotate this segment by
      let rotateDegrees = index * this.degreesPerSegment();
      // We now subtract half of the degrees per solution so that the first segment is to the left of top center
      rotateDegrees = rotateDegrees - this.degreesPerSegment() / 2 - 18;
      // set the segment width as a % of container width
      const segmentWidth = 30;

      // Calc the position left
      const positionLeft = 50 - segmentWidth / 2;

      return {
        transform: "rotate(" + rotateDegrees + "deg)",
        left: positionLeft + "%",
        width: segmentWidth + "%"
      };
    },
    segmentTitleStyle(index) {
      // Is this segment in the bottom half of the cicle?
      // that is, is its index between count * .25 and count * .75

      if (
        index > this.solutionCount * 0.25 &&
        index - 1 < this.solutionCount * 0.7
      ) {
        return {
          transform: "rotate(180deg)"
        };
      }
    },
    segmentClass(index) {
      let className = "solutions-wheel__wheel__circle__segment";
      if (index == this.active_solution_index) {
        className += " solutions-wheel__wheel__circle__segment--active";
      }
      return className;
    }
  }
};
</script>

<style lang="scss">
.solutions-wheel {
  height: 100%;
  position: relative;
  margin-bottom: 100px;

  @media screen and (max-width: 767px) {
    margin-bottom: 0;
    height: auto;
    padding-top: 32px;
  }

  &__bg,
  &__ribbon {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
  }

  &__bg {
    z-index: 1;
    height: calc(100% - 39px);
    background: rgb(220, 40, 30);
    background: linear-gradient(
      340deg,
      rgba(220, 40, 30, 1) 0%,
      rgba(220, 40, 30, 1) 40%,
      rgba(255, 122, 40, 1) 100%
    );
  }

  &__ribbon {
    height: 100%;
    z-index: 2;
    background: {
      position-x: center;
      position-y: 160px;
      repeat: no-repeat;
      size: calc(100% + 150px);
      image: url("../../../images/ribbon-solutions.png");
    }
    mix-blend-mode: overlay;

    @media all and (-ms-high-contrast: none) {
      opacity: 0.3;
    }
  }

  &__container {
    z-index: 3;
    position: relative;
    padding-top: 198px;
    width: 100%;

    @media screen and (max-width: 767px) {
      padding-top: 64px;
    }
  }

  &__header {
    padding-bottom: 24px;

    @media screen and (max-width: 768px) {
      padding-bottom: 0;
    }

    &.typography {
      color: white;

      h1,
      p {
        color: white;
      }

      p {
        font-size: 18px;
        line-height: 20px;
        font-weight: lighter;
      }
    }
  }

  &__intro {
    padding: 198px 15px 24px;
    @media screen and (max-width: 992px) {
      padding: 30px 15px 0px;
    }

    &--alongside {
      display: flex;
      @media screen and (max-width: 767px) {
        display: block;
      }
    }
  }

  &__body {
    @media screen and (max-width: 767px) {
      padding-bottom: 30px;
    }
  }

  &__wheel {
    position: relative;
    padding-top: 100%;
    max-width: 348px;

    @media screen and (max-width: 767px) {
      max-width: 100%;
      margin: 0 auto;
      /*padding-top: 80%;*/
    }

    &__circle {
      /*background: radial-gradient(rgba(255,255,255,1) 0%, rgba(255,255,255,1) 95%, rgba(255,255,255,0) 95%, rgba(255,255,255,0) 100%);*/
      background-color: white;
      width: 100%;
      box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.16);
      padding-top: 100%;
      border-radius: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      overflow: hidden;

      &__pointer {
        background: {
          image: url("../../../images/wheel/8/pointer-new.svg");
          repeat: no-repeat;
          size: contain;
          position: center center;
        }
        position: absolute;
        top: 0;
        left: 0;
        width: 50%;
        height: 50%;
        transition: transform 0.3s ease;
        transform: rotate(0);
        transform-origin: 100% 100%;
        z-index: 3;
      }

      &__hover {
        background: {
          image: url("../../../images/wheel/8/hover-new.svg");
          repeat: no-repeat;
          size: contain;
          position: center center;
        }
        position: absolute;
        top: 0;
        left: 0;
        width: 50%;
        height: 50%;
        transition: transform 0.3s ease;
        transform: rotate(0);
        transform-origin: 100% 100%;
        z-index: 2;
      }

      &__segment {
        cursor: pointer;
        position: absolute;
        color: #323232;
        top: 0;
        transform-origin: 50% 100%;
        height: 50%;
        z-index: 4;
        left: 50%;
        transform: translateX(-50%);
        transition: color 0.3s ease;
        text-align: center;

        &__title {
          height: 74px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          line-height: 1.1;
          @media screen and (max-width: 992px) {
            p {
              font-size: 12px;
            }
          }

          p {
            margin: 0 auto;
          }
        }

        &--active {
          color: white;

          &__title {
            color: white;
          }
        }
      }
    }

    &__icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -51%);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 5;
        background: #dc281e;
        border-radius: 100%;
        min-width: 220px;
        min-height: 220px;

      .inner{
        height: 76px;
        width: auto;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: space-around;
        z-index: 5;

        svg {
          height: 100%;
          width: auto;
          max-width: 250px;

          @media screen and (max-width: 1000px) and  (min-width: 760px) {
            max-width: 50px;
            max-height: 50px;
          }

          @media all and (-ms-high-contrast: none) {
            width: 172px;
            height: 172px;
          }
        }

        @include svg-styles {
          stroke: white;
        }
      }

      @media screen and (max-width: 1200px) and  (min-width: 760px) {
        min-width: 180px;
        min-height: 180px;
      }

      @media screen and (max-width: 1000px) and (min-width: 760px) {
        min-width: 110px;
        min-height: 110px;
      }

      @media screen and (max-width: 767px) {
        min-width: 65%;
        min-height: 65%;
        transform: translate(-50%, -50%);
      }

      @media screen and (max-width: 370px) {
        min-width: 60%;
        min-height: 60%;
      }
    }
  }

  &__content {
    position: relative;
    margin-top: 23px;

    &__nav {
      position: relative;
      top: 0;
      left: -20px;
      width: 81px;
      height: 40px;
      display: flex;

      &__button {
        border: 1px solid white;
        height: 40px;
        background-color: white;
        flex: 0 0 40px;
        margin-right: 1px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-around;
        transition: all 0.3s ease-in-out;

        path {
          border: 1px solid red;
          fill: #dc281e;
          transition: all 0.3s ease-in-out;
        }

        &--hover {
          border: 1px solid white;
          background-color: transparent;

          path {
            border: 1px solid red;
            fill: white;
          }
        }

        &--prev {
        }

        &--next {
          svg {
            transform: rotate(180deg);
          }
        }
      }
    }

    &__solution-info {
      padding-top: 32px;
      padding-bottom: 32px;
      color: white;
      position: relative;
      z-index: 5;

      &.typography {
        h3,
        p,
        ul,
        p.large,
        li {
          color: white;
        }

        ul {
          list-style: none;
          padding: 13px 0 10px;
          margin: 0;

          li {
            font-weight: 600;
            font-size: 14px;
            line-height: 1;
            margin-bottom: 12px;
            display: flex;
            align-items: center;

            @media screen and (max-width: 768px) {
              margin-bottom: 20px;
            }

            &:after {
              content: "";
              display: block;
              width: 11px;
              margin-left: 8px;
              height: 11px;
              background: {
                image: url("../../../images/arrow-right-white.svg");
                position: center right;
                repeat: no-repeat;
              }
              transition: margin-left 0.3s ease-in-out;
            }

            &:hover,
            &:focus {
              &:after {
                margin-left: 12px;
              }
            }

            a {
              color: white;
              margin-bottom: 0;
              position: relative;
            }
          }
        }

        > div > a,
        > div > p > a {
          border: 1px solid white;
          color: white;
          padding: 12px 16px;
          margin-top: 24px;
          display: inline-block;
          transition: all 0.3s ease-in-out;

          &:hover,
          &:focus {
            background-color: white;
            color: red;
          }
        }
      }

      &--links{
        padding-top: 120px;

        @media screen and (max-width: 768px) {
          padding-top: 0;
        }
      }
    }
  }
}
</style>
